import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    creatorsManagementList: [],
    managementTotalPages: 0,
    page: 0,
    size: 0,
    total: 0,
    loaderForButton: false,
    managmentCreatorsLoader: false,
    isAddProductSuccess: 0,
    productConfigData: "null"
}

const campaignManagementSLice = createSlice({
    name: 'campaignManagement',
    initialState,
    reducers: {
        setCreatorsManagement(state, action) {
            state.creatorsManagementList = action?.payload?.pagination ? [...state?.creatorsManagementList, ...action?.payload?.creatorsManagementList] : action?.payload?.creatorsManagementList;
            state.page = action?.payload?.page;
            state.size = action?.payload?.size;
            state.total = action?.payload?.total;
            state.managmentCreatorsLoader = action?.payload?.managmentCreatorsLoader;
            state.loaderForButton = action.payload.loaderForButton || false;
            state.managementTotalPages = action?.payload?.managementTotalPages;
        },
        setLoaderForButton(state, action) {
            state.loaderForButton = action?.payload?.loaderForButton;
        },
        setmanagmentCreatorsLoader(state, action) {
            state.managmentCreatorsLoader = action?.payload;
        },
        clearCampaignManagement(state, action) {
            return initialState;
        },
        setIsAddProductSuccess(state, action) {
            if (typeof state.isAddProductSuccess === 'number') {
              state.isAddProductSuccess += 1; // increment count
            }
        },
        setProductConfigData(state, action) {
            state.productConfigData = action?.payload?.productConfigData;
        },
    }
})

export const campaignManagementActions = campaignManagementSLice.actions;

export default campaignManagementSLice;